module.exports = __webpack_public_path__ + "img/page8.62cc3898.png";